//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { EmailBuilderPanelActionType } from '@email-builder/actions/emailBuilderPanelActions';
import { EMAIL_BUILDER_ACTIONS,  EMAIL_PREVIEW_TYPE, TAB_INDICES, TAB_TITLES } from '@email-builder/constants/emailBuilderConstants';
import { IEmailBuilderPanel } from '@email-builder/models/emailBuilderStateModel';

const initialState: IEmailBuilderPanel = {
  currentPanel: TAB_INDICES.LAYOUT,
  numPanels: TAB_TITLES.length,
  previewType: EMAIL_PREVIEW_TYPE.DESKTOP,
};

export default function EmailBuilderPanelReducer(
  state: IEmailBuilderPanel = initialState,
  action: EmailBuilderPanelActionType,
) {
  switch (action.type) {
    case EMAIL_BUILDER_ACTIONS.SET_CURRENT_PANEL: {
      return {
        ...state,
        currentPanel: action.panel,
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_EMAIL_PREVIEW_TYPE: {
      return {
        ...state,
        previewType: action.previewType
      };
    }
    default:
      return state;
  }
}
